import React from "react";
import MainLayout from "../../components/Layouts";
import AddRequestedProduct from "../../components/RequestedProduct/AddProduct";

const AddRequestedProductPage = () => {
  return (
    <MainLayout> 
      <AddRequestedProduct />
    </MainLayout>
  );
};

export default AddRequestedProductPage;
